
    <button
      [style.display]="'none'"
      *ngIf="Pwa.promptEvent"
      (click)="installPwa()"
    >
      Install
    </button>
    <router-outlet></router-outlet>
  